import {
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneItemGenerator, RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoGridOneColumn, RaikoGridTwoColumn, RaikoSectionContainer, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useState} from "react";
import {GameTeamMemberService} from "../../../serverService/gameService/GameTeamMemberService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function AddPlayerToTeam({gameTeamId,playerInfo,handleBackPage,handleClosePlayerSelectionDialog}) {
    const [gameRole, setGameRole] = useState("MEMBER")

    const service = new GameTeamMemberService()

    const loading = new LoadingHelper(useLoadingDispatcher())


    function handleAddNewPlayer() {
        loading.show()
        service.addNewPlayerToTeam(
            gameTeamId,
            playerInfo.id,
            gameRole
        ).then(
            response=>{
                showSuccessMessage("بازیکن جدید با موفقیت افزوده شد")
                handleClosePlayerSelectionDialog()
            }
        ).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_=>{
            loading.hide()
        })

    }




    return(
        <RaikoGridTwoColumn>
            <RaikoCardInfoTypeOne
            title={playerInfo.displayName}
            titleLabel={playerInfo.phoneNumber}
            iconClass={"ic-profile"}
            items={[
                RaikoCardInfoTypeOneItemGenerator("کد ملی", playerInfo.nationalCode),
                RaikoCardInfoTypeOneItemGenerator("جنسیت", playerInfo.gender),
                RaikoCardInfoTypeOneItemGenerator("تاریخ تولد", playerInfo.birthdate),
            ]}
            />
            <RaikoSectionContainer
                title={"انتخاب نقش عضو"}
                hasActionButton
                actionButtonOnclick={handleAddNewPlayer}
                actionButtonTitle={"ثبت"}
                hasSecondaryButton
                secondaryButtonTitle={"بازگشت"}
                secondaryButtonOnClick={handleBackPage}
            >
                <RaikoCustomSelect
                    labelText={"انتخاب نقش"}
                    value={gameRole}
                    setValue={setGameRole}
                    items={[
                        raikoCustomSelectItemGenerator("LEADER", "کاپیتان"),
                        raikoCustomSelectItemGenerator("MEMBER", "عضو"),
                    ]}

                />
            </RaikoSectionContainer>


        </RaikoGridTwoColumn>
    )
}